import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=a323b536&scoped=true&"
import script from "./finish.vue?vue&type=script&lang=js&"
export * from "./finish.vue?vue&type=script&lang=js&"
import style0 from "./finish.vue?vue&type=style&index=0&id=a323b536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a323b536",
  null
  
)

export default component.exports